// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d2022650","453":"d3bc73ad","667":"49268c09","977":"4e7c6961"}[chunkId] + ".chunk.js";
};